// ReusableEditor.tsx
import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// 1. REMOVE DEFAULT LIST AUTO-FILL
// --------------------------------------
const keyboard = Quill.import("modules/keyboard");
const defaultBindings = keyboard.DEFAULTS.bindings;

delete defaultBindings["list autofill"];
delete defaultBindings["list autofill short"];
delete defaultBindings["ordered list autofill"];
delete defaultBindings["bullet list autofill"];

// --------------------------------------
// 2. FORCE <div> INSTEAD OF <p>
// --------------------------------------
const Block = Quill.import("blots/block");
Block.tagName = "div";
Quill.register(Block, true);

// --------------------------------------
// 3. YOUR MODULES
// --------------------------------------
export const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // [{ font: [] }], // font family - Sans Serif, Serif & mono
    // [{ size: ["small", false, "large", "huge"] }], // font size - small, large, huge
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    // [{ list: "ordered" }, { list: "bullet" }],
    // [{ indent: "-1" }, { indent: "+1" }],
    // [{ align: [] }],
    // ["blockquote", "code-block"],
    ["link", "image", "video"],
    // ["clean"],
  ],

  keyboard: {
    bindings: {
      orderedList: {
        key: " ",
        shiftKey: false,
        collapsed: true,
        prefix: /^1\.$/,
        handler: () => true,
      },
      bulletDash: {
        key: " ",
        collapsed: true,
        prefix: /^-$/,
        handler: () => true,
      },
      bulletStar: {
        key: " ",
        collapsed: true,
        prefix: /^\*$/,
        handler: () => true,
      },
    },
  },
};

export const editorFormats = [
  "header",
  // "font", // font family - Sans Serif, Serif & mono
  // "size", // font size - small, large, huge
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "align",
  "blockquote",
  "code-block",
  "link",
  "image",
  "video",
];

// --------------------------------------
const TextEditor = ({ value, onChange, placeholder, height = 300 }) => {
  return (
    <div className="custom-quill" style={{ "--editor-height": `${height}px` }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder || "Type here..."}
        modules={editorModules}
        formats={editorFormats}
      />
    </div>
  );
};

export default TextEditor;
